const accountsEligibleCountriesWithCurrencies = [
  { name: 'American Samoa', code: 'AS', currencies_codes: ['USD'] },
  { name: 'Argentina', code: 'AR', currencies_codes: ['ARS'] },
  { name: 'Australia', code: 'AU', currencies_codes: ['AUD'] },
  { name: 'Austria', code: 'AT', currencies_codes: ['EUR'] },
  { name: 'Belgium', code: 'BE', currencies_codes: ['EUR'] },
  { name: 'Brazil', code: 'BR', currencies_codes: ['BRL'] },
  { name: 'Bulgaria', code: 'BG', currencies_codes: ['EUR'] },
  { name: 'Canada', code: 'CA', currencies_codes: ['CAD', 'USD'] },
  { name: 'China', code: 'CN', currencies_codes: ['CNY'] },
  { name: 'Colombia', code: 'CO', currencies_codes: ['COP'] },
  { name: 'Croatia', code: 'HR', currencies_codes: ['EUR'] },
  { name: 'Cyprus', code: 'CY', currencies_codes: ['EUR'] },
  { name: 'Czech Republic', code: 'CZ', currencies_codes: ['EUR', 'CZK'] },
  { name: 'Denmark', code: 'DK', currencies_codes: ['EUR', 'DKK'] },
  { name: 'Estonia', code: 'EE', currencies_codes: ['EUR'] },
  { name: 'Finland', code: 'FI', currencies_codes: ['EUR'] },
  { name: 'France', code: 'FR', currencies_codes: ['EUR'] },
  { name: 'Gibraltar', code: 'GI', currencies_codes: ['EUR', 'GBP'] },
  { name: 'Greece', code: 'GR', currencies_codes: ['EUR'] },
  { name: 'Guadeloupe', code: 'GP', currencies_codes: ['EUR'] },
  { name: 'Guernsey', code: 'GG', currencies_codes: ['EUR', 'GBP'] },
  { name: 'Hong Kong', code: 'HK', currencies_codes: ['HKD'] },
  { name: 'Hungary', code: 'HU', currencies_codes: ['EUR', 'HUF'] },
  { name: 'Iceland', code: 'IS', currencies_codes: ['EUR'] },
  { name: 'Indonesia', code: 'ID', currencies_codes: ['IDR'] },
  { name: 'Ireland', code: 'IE', currencies_codes: ['EUR'] },
  { name: 'Isle of Man', code: 'IM', currencies_codes: ['EUR', 'GBP'] },
  { name: 'Israel', code: 'IL', currencies_codes: ['ILS'] },
  { name: 'Italy', code: 'IT', currencies_codes: ['EUR'] },
  { name: 'Japan', code: 'JP', currencies_codes: ['JPY'] },
  { name: 'Jersey', code: 'JE', currencies_codes: ['EUR', 'GBP'] },
  { name: 'Latvia', code: 'LV', currencies_codes: ['EUR'] },
  { name: 'Liechtenstein', code: 'LI', currencies_codes: ['EUR', 'CHF'] },
  { name: 'Lithuania', code: 'LT', currencies_codes: ['EUR'] },
  { name: 'Malta', code: 'MT', currencies_codes: ['EUR'] },
  { name: 'Martinique', code: 'MQ', currencies_codes: ['EUR'] },
  { name: 'Mayotte', code: 'YT', currencies_codes: ['EUR'] },
  { name: 'Mexico', code: 'MX', currencies_codes: ['MXN'] },
  { name: 'Monaco', code: 'MC', currencies_codes: ['EUR'] },
  { name: 'Netherlands', code: 'NL', currencies_codes: ['EUR'] },
  { name: 'New Zealand', code: 'NZ', currencies_codes: ['NZD'] },
  { name: 'Norway', code: 'NO', currencies_codes: ['EUR', 'NOK'] },
  { name: 'Peru', code: 'PE', currencies_codes: ['PEN'] },
  { name: 'Poland', code: 'PL', currencies_codes: ['EUR', 'PLN'] },
  { name: 'Portugal', code: 'PT', currencies_codes: ['EUR'] },
  { name: 'Puerto Rico', code: 'PR', currencies_codes: ['USD'] },
  { name: 'Romania', code: 'RO', currencies_codes: ['EUR'] },
  { name: 'Russia', code: 'RU', currencies_codes: ['RUB'] },
  { name: 'Saint Barthelemy', code: 'BL', currencies_codes: ['EUR'] },
  { name: 'Saint Pierre and Miquelon', code: 'PM', currencies_codes: ['EUR'] },
  { name: 'San Marino', code: 'SM', currencies_codes: ['EUR'] },
  { name: 'Singapore', code: 'SG', currencies_codes: ['SGD'] },
  { name: 'Slovakia', code: 'SK', currencies_codes: ['EUR'] },
  { name: 'Slovenia', code: 'SI', currencies_codes: ['EUR'] },
  { name: 'Spain', code: 'ES', currencies_codes: ['EUR'] },
  { name: 'Sweden', code: 'SE', currencies_codes: ['EUR', 'SEK'] },
  { name: 'Switzerland', code: 'CH', currencies_codes: ['EUR', 'CHF'] },
  { name: 'United Kingdom', code: 'GB', currencies_codes: ['EUR', 'GBP'] },
  { name: 'United States', code: 'US', currencies_codes: ['USD'] },
  { name: 'Viet Nam', code: 'VN', currencies_codes: ['EUR'] },
];

export { accountsEligibleCountriesWithCurrencies };
